const launch = {
  path: 'launch',
  component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/launch'], resolve),
  meta: {isLaunch: true}
}

export default launch
